/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, object, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Slider from 'react-slick';

import ProductBlogContent from './ProductBlogContent';

const styles = (theme) => ({
    sliderContainer: {
        maxWidth: '100%',
        '& .slick-slider': {
            '& button[data-component="prevArrow"], button[data-component="nextArrow"]': {
                display: 'none',
                color: theme.palette.primary,
            },
            '& button': {
                margin: 'auto',
            },
            '& .slick-dots': {
                bottom: 0,
                '& button': {
                    '&::before': {
                        width: theme.spacing(3),
                        height: theme.spacing(3),
                        border: `1px solid ${theme.palette.common.black}`,
                        content: '""',
                        fontSize: '1.25rem',
                        borderRadius: '50%',
                        backgroundColor: theme.palette.black,
                    },
                },
            },
        },
    },
});

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button type="button" onClick={onClick}>
            <i className="material-icons text-icon">&#xE315;</i>
        </button>
    );
};
NextArrow.propTypes = {
    onClick: func.isRequired,
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <button type="button" onClick={onClick}>
            <i className="material-icons text-icon">&#xE408;</i>
        </button>
    );
};

PrevArrow.propTypes = {
    onClick: func.isRequired,
};

const ProductBlogSlider = ({
    classes, setting, data,
}) => {
    const settings = {
        ...setting,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };
    /* eslint-disable react/jsx-props-no-spreading */
    return (
        <div className={classes?.sliderContainer}>
            <Slider {...settings}>
                {data && data.map((item) => (
                    <ProductBlogContent key={`${item.blogTitle}`} blogDetails={item} />
                ),
                )}
            </Slider>
        </div>
    );
};

ProductBlogSlider.propTypes = {
    classes: object.isRequired,
    data: array.isRequired,
    setting: object.isRequired,
};

export default withStyles(styles)(ProductBlogSlider);
